package com.kanati.shared.school

import kotlinx.serialization.Serializable

@Serializable
data class School(
    val id: String,
    val districtId: String,
    val name: String,
    val shortName: String? = null,
    val active: Boolean,
    val createdAt: String,
)

@Serializable
data class CreateSchoolRequest(
    val districtId: String,
    val name: String,
    val shortName: String? = null,
    val active: Boolean = true,
)

@Serializable
data class UpdateSchoolRequest(
    val districtId: String,
    val name: String? = null,
    val shortName: String? = null,
    val active: Boolean? = null,
)
